import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ToolLayout } from '@/components/common/ToolLayout';

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '404 - Page Not Found | wealthcalc';
  }, []);

  return (
    <ToolLayout
      title="404 Error"
      description="The page you’re looking for doesn’t exist."
      category="Error"
    >
      <div className="flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-2xl">
          <div className="text-center space-y-8">
            {/* 404 */}
            <div className="space-y-4">
              <div className="text-8xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
                404
              </div>
              <h1 className="text-4xl font-bold">
                Page Not Found
              </h1>
              <p className="text-lg text-muted-foreground max-w-md mx-auto">
                The page you're looking for doesn't exist or has been moved.
              </p>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={() => navigate('/')}>
                Home
              </Button>
              <Button variant="outline" onClick={() => navigate('/explore')}>
                Explore Tools
              </Button>
              <Button variant="outline" onClick={() => navigate('/contact')}>
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ToolLayout>
  );
}
